import {
  ArrowTopRightOnSquareIcon,
  DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { DATE_DOT_FORMAT, serviceOptions } from "../../../../constants";
import type { ServiceType } from "../../../../types/forms";
import { format, parseISO } from "date-fns";

export type OrderSummary = {
  ebayOrderId: string;
  serviceType: ServiceType;
  datePlaced: string;
  subtotal: number;
  taxes: number;
  shippingFee: number;
  totalCost: number;
};

export default function OrderSummaryCard({
  summary,
}: {
  summary: OrderSummary;
}) {
  const formattedDate = format(parseISO(summary.datePlaced), DATE_DOT_FORMAT);

  return (
    <section className="overflow-hidden rounded-xl border border-gray-100 bg-white">
      <div className="flex items-center gap-2 border-b border-gray-100 px-4 md:px-5 py-4.5">
        <DocumentTextIcon className="size-5 text-blue-600" />
        <h2 className="text-sm md:text-base font-medium text-gray-950">
          Order Summary
        </h2>
      </div>

      <div className="flex flex-col px-4 md:px-5 py-1.5 text-sm">
        <SummaryRow label="eBay Order ID">{summary.ebayOrderId}</SummaryRow>
        <SummaryRow label="eBay Service">
          <button
            type="button"
            className="flex items-center gap-1.5 text-blue-600 hover:text-blue-700 cursor-pointer"
          >
            View on eBay
            <ArrowTopRightOnSquareIcon className="size-4" />
          </button>
        </SummaryRow>
        <SummaryRow label="Service Type">
          {serviceOptions.find((o) => o.value === summary.serviceType)?.label}
        </SummaryRow>
        <SummaryRow label="Date Placed">{formattedDate}</SummaryRow>
        <SummaryRow label="Subtotal">${summary.subtotal.toFixed(2)}</SummaryRow>
        <SummaryRow label="Taxes">${summary.taxes.toFixed(2)}</SummaryRow>
        <SummaryRow label="Shipping Fee">
          ${summary.shippingFee.toFixed(2)}
        </SummaryRow>
        <SummaryRow label="Total Cost">
          ${summary.totalCost.toFixed(2)}
        </SummaryRow>
      </div>
    </section>
  );
}

const SummaryRow = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex items-center justify-between gap-4 border-b border-gray-100 py-3.5 last:border-b-0">
    <span className="shrink-0 text-gray-500">{label}</span>
    <span className="flex min-w-0 justify-end break-all text-right text-gray-950">
      {children}
    </span>
  </div>
);
